import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {nil} from "felles-ng2/typer/nullish";
import {Behandlingssted} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {KonferanselenkePipe} from "felles-ng2/pipes/KonferanselenkePipe";

const debug = initDebugger('BehandlingsstedKomponent');

@Component({
    selector: 'behandlingssted',
    templateUrl: './behandlingssted.html',
    imports: [
        KonferanselenkePipe,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BehandlingsstedKomponent {
    static ajsSelector = 'behandlingssted';

    @Input() behandlingssted: Behandlingssted | nil;

    constructor() {
    }
}
